// extracted by mini-css-extract-plugin
export default {"root":"Radio_root_ZQ7Vp","label":"Radio_label_Bo0_8","input":"Radio_input_gqAMo"};